module.exports = __webpack_public_path__ + "static/img/top-winners.f36ea20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programs/top-winners.jpg
// module id = /C2s
// module chunks = 1